import AutoplayModel from "../../../core/src/model/AutoplayModel";
import PointerEvents from "../../../core/src/const/PointerEvents";
import BetModel from "../../../core/src/model/BetModel";
import ViewManager from "../../../core/src/utils/ViewManager";
import UIController from "../../../core/src/ui/UIController";
import SoundController from "../../../core/src/utils/SoundController";
import SoundVars from "../../../core/src/const/SoundVars";
import CommandManager from "../../../core/src/commands/CommandManager";
import { Commands } from "../../../core/src/commands/CommandEnum";
import SwitchButton from "../../../core/src/views/components/SwitchButton";
import GameModel from "../../../core/src/model/GameModel";
import BaseUI from "../../../core/src/ui/BaseUI";
import Checkbox from "../../../core/src/views/components/Checkbox";


export default class AutoplayPage extends BaseUI {

    protected stopOnFeatureCheckBox:Checkbox;
    protected stopOnBigWinCheckBox:Checkbox;
    constructor() {
        super()
        this.scene = ViewManager.getLayer("MenusContent").setScene("autoplay");
    }

    public update(event: string) {};

    create() {
        super.create();

        let autospins = this.scene.buttonGroups.get("spinsCount");
        let lossLimit = this.scene.buttonGroups.get("lossAmount");
      //  let singleWinLimit = this.scene.buttonGroups.get("winAmount");
        let clearBtn = this.scene.buttons.get("clear");
        let playBtn = this.scene.buttons.get("play");
        let isFeatureAllowed = !GameModel.gameConfig.disableAutoplay;
        //   let scene = ViewManager.getLayer("MenusContent").setScene("autoplay");

        this.stopOnFeatureCheckBox = new Checkbox(
            this.scene.sceneSprites.get("box-stop_on_feature"),
            this.scene.sceneSprites.get("check-stop_on_feature"),
            this.scene.sceneTextFields.get("stop_on_feature")
        );

        this.stopOnBigWinCheckBox = new Checkbox(
            this.scene.sceneSprites.get("box-stop_on_big_win"),
            this.scene.sceneSprites.get("check-stop_on_big_win"),
            this.scene.sceneTextFields.get("stop_on_big_win")
        );

        let updatePlayButton = () => {
            let enabled =
                isFeatureAllowed &&
                autospins.isSelected() &&
                lossLimit.isSelected() //&&
                //singleWinLimit.isSelected();
            playBtn.setEnabled(enabled);
        };

        const saveSettings = () => {
            //     CommandManager.execute(Commands.SAVE_SETTINGS);
        };

        ////////////////
        // AUTO SPIN COUNT
        ////////////////
        let autospinValues = AutoplayModel.spinPresets;
        if (autospinValues.length == 0) {
            throw new Error("AutoplayModel.spinPresets must be set!");
        }

        autospins.replaceButtonTexts((value, index) =>
            autospinValues[autospins.getChildren().length - 1 - index] ?
                String(autospinValues[autospins.getChildren().length - 1 - index]) :
                null
        );

        // Loop through the values to select the current one
        autospins.getChildren().forEach((child: SwitchButton) => {
            child.setEnabled(isFeatureAllowed);
            const value = parseFloat(child.getValue());
            let shouldSwitch = false;
            if (AutoplayModel.getAutoSpinNum() > 0) {
                shouldSwitch = AutoplayModel.getAutoSpinNum() == value;
            } else {
                shouldSwitch = AutoplayModel.defaultSpinPreset == value;
            }
            
            if (shouldSwitch) {
                // Will auto toggle the default autospin count switch button.
                AutoplayModel.setAutoSpin(value);
                updatePlayButton();
                saveSettings();
            }

            child.switch(shouldSwitch);
        });

        ////////////////
        // LOSS LIMIT
        ////////////////
        let lossLimits = AutoplayModel.lossLimits;
        if (lossLimits.length == 0) {
            throw new Error("AutoplayModel.lossLimits must be set!")
        }

        // Old code
        // lossLimit.replaceButtonTexts((value, index) =>
        //     value.replace("{0}", String(lossLimits[lossLimits.length - 1 - index]))
        // );

        // New code
        let childIndex = 0;
        lossLimit.getChildren().reverse().forEach((switchButton: SwitchButton) => {
            if (childIndex < lossLimits.length) {
                switchButton.text.text = "x" + String(lossLimits[childIndex++]);
            }
        });

        // Loop through the values to select the current one
        lossLimit.getChildren().forEach((child: SwitchButton) => {
            child.setEnabled(isFeatureAllowed);
            let buttonValue =
                Number(child.getValue().split("x")[1]) * BetModel.totalBet;
            child.switch(buttonValue == AutoplayModel.getLossLimit());
        });

        ////////////////
        // WIN LIMIT
        ////////////////
        // let singleWinLimits = AutoplayModel.singleWinLimits;
        // if (singleWinLimits.length == 0) {
        //     singleWinLimits = [2, 5, 10, 20];
        // }
        // singleWinLimit.replaceButtonTexts((value, index) =>
        //     value.replace(
        //         "{0}",
        //         String(singleWinLimits[singleWinLimits.length - 1 - index])
        //     )
        // );
        // Loop through the values to select the current one
        // singleWinLimit.getChildren().forEach((child: SwitchButton) => {
        //     child.setEnabled(isFeatureAllowed);
        //     let buttonValue =
        //         Number(child.getValue().split("x")[0]) * BetModel.totalBet;
        //     child.switch(buttonValue == AutoplayModel.getWinLimit());
        // });

        this.stopOnBigWinCheckBox.setIsSelected(AutoplayModel.stopOnBigWin);

        this.stopOnBigWinCheckBox.on(PointerEvents.UPDATE,()=>{
            CommandManager.execute(Commands.TOGGLE_AUTOPLAY_STOP_ON_BIG_WIN);
        });

        this.stopOnFeatureCheckBox.setIsSelected(AutoplayModel.stopOnFeatureWin);
        this.stopOnFeatureCheckBox.on(PointerEvents.UPDATE,()=>{
            CommandManager.execute(Commands.TOGGLE_AUTOPLAY_STOP_ON_FEATURE_WIN);
        });

        clearBtn.setEnabled(isFeatureAllowed);



        lossLimit.onSelect((value) => {
            SoundController.playSound(SoundVars.BUTTON_CLICK);
            value = Number(value.split("x")[1]) * BetModel.totalBet;
            AutoplayModel.setLossLimit(Number(value));
            updatePlayButton();
            saveSettings();
        });

        // singleWinLimit.onSelect((value) => {
        //     SoundController.playSound(SoundVars.BUTTON_CLICK);
        //     value = Number(value.split("x")[0]) * BetModel.totalBet;
        //     AutoplayModel.setWinLimit(Number(value));
        //     updatePlayButton();
        //     saveSettings();
        // });

        autospins.onSelect((value) => {
            SoundController.playSound(SoundVars.BUTTON_CLICK);
            value = Number(value.split("x")[0]);
            AutoplayModel.setAutoSpin(value);
            AutoplayModel.defaultSpinPreset = value;
            updatePlayButton();
            saveSettings();
        });

        clearBtn.on(PointerEvents.DOWN, () => {
            SoundController.playSound(SoundVars.BUTTON_CLICK);
            lossLimit.deselect();
            //singleWinLimit.deselect();
            this.stopOnBigWinCheckBox.setIsSelected(false);
            this.stopOnFeatureCheckBox.setIsSelected(false);
            autospins.deselect();
            AutoplayModel.setAutoSpin(0);
            AutoplayModel.setWinLimit(0);
            AutoplayModel.setLossLimit(0);
            // StopAutoplayCommand();
            updatePlayButton();
            saveSettings();
        });

        //   playBtn.on(PointerEvents.DOWN, () => {
        //     SoundController.playSound(SoundVars.BUTTON_CLICK);
        //     CommandManager
        //     UIController.toggleComponent("settings");
        //   });
        this.assignInterraction([Commands.START_AUTOPLAY, Commands.TOGGLE_SETTINGS], playBtn);

        updatePlayButton();
    }

}
